import { Rules1004 } from './schemas/1004.model';
import { Rules1073 } from './schemas/1073.model';
import { Rules1075 } from './schemas/1075.model';
import { Rules2055 } from './schemas/2055.model';

export class RulesModel {
	rules = {
		'CVReview:1': {
			overview: {
				rulesBase: Rules1004.OVERVIEW
			},
			revisions: {
				rulesBase: Rules1004.REVISIONS
			},
			subject: {
				rulesBase: Rules1004.SUBJECT
			},
			neighborhood: {
				rulesBase: Rules1004.NEIGHBORHOOD
			},
			improvements: {
				rulesBase: Rules1004.IMPROVEMENTS
			},
			comps: {
				rulesBase: Rules1004.COMPS
			},
			salesapproach: {
				rulesBase: Rules1004.SALESAPPROACH
			},
			costapproach: {
				rulesBase: Rules1004.COSTAPPROACH
			},
			incomeapproach: {
				rulesBase: Rules1004.INCOMEAPPROACH
			},
			reconciliation: {
				rulesBase: Rules1004.RECONCILIATION
			},
			pdfreview: {
				rulesBase: Rules1004.PDFREVIEW
			},
			photoreview: {
				rulesBase: Rules1004.PHOTOREVIEW
			}
		},
		'CVReview1073:1': {
			overview: {
				rulesBase: Rules1073.OVERVIEW
			},
			revisions: {
				rulesBase: Rules1073.REVISIONS
			},
			subject: {
				rulesBase: Rules1073.SUBJECT
			},
			neighborhood: {
				rulesBase: Rules1073.NEIGHBORHOOD
			},
			projectinformation: {
				rulesBase: Rules1073.PROJECTINFORMATION
			},
			projectanalysis: {
				rulesBase: Rules1073.PROJECTANALYSIS
			},
			unitdescription: {
				rulesBase: Rules1073.UNITDESCRIPTION
			},
			comps: {
				rulesBase: Rules1073.COMPS
			},
			salesapproach: {
				rulesBase: Rules1073.SALESAPPROACH
			},
			incomeapproach: {
				rulesBase: Rules1073.INCOMEAPPROACH
			},
			reconciliation: {
				rulesBase: Rules1073.RECONCILIATION
			},
			pdfreview: {
				rulesBase: Rules1073.PDFREVIEW
			},
			photoreview: {
				rulesBase: Rules1073.PHOTOREVIEW
			}
		},
		'CVReview1075:1': {
			overview: {
				rulesBase: Rules1075.OVERVIEW
			},
			revisions: {
				rulesBase: Rules1075.REVISIONS
			},
			subject: {
				rulesBase: Rules1075.SUBJECT
			},
			neighborhood: {
				rulesBase: Rules1075.NEIGHBORHOOD
			},
			projectinformation: {
				rulesBase: Rules1075.PROJECTINFORMATION
			},
			projectanalysis: {
				rulesBase: Rules1075.PROJECTANALYSIS
			},
			unitdescription: {
				rulesBase: Rules1075.UNITDESCRIPTION
			},
			comps: {
				rulesBase: Rules1075.COMPS
			},
			salesapproach: {
				rulesBase: Rules1075.SALESAPPROACH
			},
			incomeapproach: {
				rulesBase: Rules1075.INCOMEAPPROACH
			},
			reconciliation: {
				rulesBase: Rules1075.RECONCILIATION
			},
			pdfreview: {
				rulesBase: Rules1075.PDFREVIEW
			},
			photoreview: {
				rulesBase: Rules1075.PHOTOREVIEW
			}
		},
		'CVReview2055:1': {
			overview: {
				rulesBase: Rules2055.OVERVIEW
			},
			revisions: {
				rulesBase: Rules2055.REVISIONS
			},
			subject: {
				rulesBase: Rules2055.SUBJECT
			},
			neighborhood: {
				rulesBase: Rules2055.NEIGHBORHOOD
			},
			improvements: {
				rulesBase: Rules2055.IMPROVEMENTS
			},
			comps: {
				rulesBase: Rules2055.COMPS
			},
			salesapproach: {
				rulesBase: Rules2055.SALESAPPROACH
			},
			costapproach: {
				rulesBase: Rules2055.COSTAPPROACH
			},
			incomeapproach: {
				rulesBase: Rules2055.INCOMEAPPROACH
			},
			reconciliation: {
				rulesBase: Rules2055.RECONCILIATION
			},
			pdfreview: {
				rulesBase: Rules2055.PDFREVIEW
			},
			photoreview: {
				rulesBase: Rules2055.PHOTOREVIEW
			}
		}
	};
}